<template>
  <section>
    <v-dialog
      v-model="isShow"
      width="400px">
      <div class="dialog-container">
        <div class="dialog-header">
          <span>Edit User Blocks</span>
          <font-awesome-icon
            icon="times"
            class="pointer"
            @click="handleCancel"></font-awesome-icon>
        </div>
        <div class="dialog-body">
          <!--          <el-checkbox-->
          <!--            v-model="all"-->
          <!--            class="all"-->
          <!--            @change="handleAll">All</el-checkbox>-->
          <v-checkbox-group
            v-model="class_id"
            :list="allSelect"
            @input="handleAll"></v-checkbox-group>
          <v-checkbox-group
            v-model="class_id"
            :list="classList"
            :disabled="isSelectAll"
            @input="handleChangeList"></v-checkbox-group>
          <div class="form-item mg-t-10">
            <span>Remarks</span>
            <v-input
              v-model="remark"
              type="textarea"
              :rows="4"></v-input>
          </div>
        </div>
        <div class="dialog-footer">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleSave">Save</v-button>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {editUserBlocks} from '@/api/account'

export default {
  name: 'EditUserBlocks',
  mixins:[MixinOptions],
  props:{
    customerId:{
      type: [String, Number],
      default: ''
    },
    detailData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isShow: false,
      all: false,
      class_id: [],
      remark:''
    }
  },
  computed:{
    isSelectAll(){
      return this.class_id.includes(0)
    },
    allSelect(){
      return[
        {
          id: 0,
          name: 'All'

        }
      ]
    },
    classList(){
      let arr = this.globalOptions.class_data.filter(item => item.id < 50) || []
      // arr.unshift()
      return arr
    },
    allClass(){
      return this.classList.reduce((res, item) => {
        res.push(item.id)
        return res
      }, [])
    }
  },
  watch:{
    'detailData.block_data':{
      immediate: true,
      handler(val){
        if(val){
          this.class_id = JSON.parse(JSON.stringify(val))
          this.handleChangeList()
        }
      }
    }
  },
  methods: {
    changeDialog(){
      this.isShow = !this.isShow
    },
    handleCancel(){
      this.isShow = false
    },
    handleSave(){
      let params = {
        customer_id: this.customerId,
        class_id: this.class_id,
        remark:this.remark
      }
      this.network().editUserBlocks(params)
    },
    handleAll(){
      // console.log('data--',this.class_id,this.isSelectAll)
      if(this.isSelectAll){
        this.class_id = [0]
      }else{
        this.class_id = []
      }
    },
    handleChangeList(){
      const data = this.class_id.sort()
      // console.log('data--',data,this.class_id)
      // if(this.isSelectAll){
      //   this.class_id = [0]
      // }
    },
    network(){
      return {
        editUserBlocks: async (params) => {
          const {data} = await editUserBlocks(params)
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.handleCancel()
            this.$emit('update')
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
}
.dialog-container {
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    display: flex;
    justify-content: space-between;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .all{
      margin-bottom: 5px;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    padding-top: 0;
  }
}
/deep/.el-checkbox-group{
  flex-direction: column;
}
</style>
